/* eslint-disable */
export default {
    "bumblesite@global_trends_report_2025.block.one.title": 0,
    "bumblesite@global_trends_report_2025.block.one.text": 1,
    "bumblesite@global_trends_report_2025.block.two.title": 2,
    "bumblesite@global_trends_report_2025.block.two.text": 3,
    "bumblesite@global_trends_report_2025.block.three.title": 4,
    "bumblesite@global_trends_report_2025.block.three.text": 5,
    "bumblesite@global_trends_report_2025.block.four.title": 6,
    "bumblesite@global_trends_report_2025.block.four.text": 7,
    "bumblesite@global_trends_report_2025.block.five.title": 8,
    "bumblesite@global_trends_report_2025.block.five.text": 9,
    "bumblesite@global_trends_report_2025.block.six.title": 10,
    "bumblesite@global_trends_report_2025.block.six.text": 11,
    "bumblesite@global_trends_report_2025.block.disclaimer": 12,
} as const;
